/**
 * Community Message Like Remapper
 * Flutter: lib/data/models/community_message_like.dart
 */
import type { CommunityMessageLikeDto } from '@/data/dtos/communityMessageLike/communityMessageLikeDto';
import type { JsonObject } from '@/data/types/json';
import type { CommunityMessageLikeStorage } from '@/domain/entities/secureStorage/secureStorageEntities';

export class CommunityMessageLikeRemapper {
  static toStorage(dto: CommunityMessageLikeDto): CommunityMessageLikeStorage {
    return {
      userId: dto.userId,
      communityMessageId: dto.communityMessageId,
      parentCommunityMessageId: dto.parentCommunityMessageId,
      liked: dto.liked,
      createdDate: dto.createdDate,
      updatedDate: dto.updatedDate,
    };
  }

  static fromJson(data: JsonObject): CommunityMessageLikeDto {
    return {
      userId: (data['userId'] as string | undefined) ?? '',
      communityMessageId: (data['communityMessageId'] as string | undefined) ?? '',
      parentCommunityMessageId: data['parentCommunityMessageId'] as string | undefined,
      liked: (data['liked'] as boolean | undefined) ?? false,
      createdDate: (data['createdDate'] as number | undefined) ?? 0,
      updatedDate: data['updatedDate'] as number | undefined,
    };
  }

  static fromJsonList(dataList: JsonObject[]): CommunityMessageLikeDto[] {
    return dataList.map(CommunityMessageLikeRemapper.fromJson);
  }

  /**
   * Serialize a like DTO to the Firestore document shape.
   *
   * Mirrors the generated `_$CommunityMessageLikeToJson`
   * (lib/data/models/community_message_like.g.dart:70-79): all six fields are
   * written, with `parentCommunityMessageId` and `updatedDate` emitted as
   * explicit `null` when unset (Flutter writes explicit nulls, so the web
   * document shape must match — data-layer.md JsonKey/field parity). The Dart
   * model has no `@JsonKey`, so property name = Firestore field name (no renames).
   */
  static toJson(dto: CommunityMessageLikeDto): JsonObject {
    return {
      userId: dto.userId,
      communityMessageId: dto.communityMessageId,
      parentCommunityMessageId: dto.parentCommunityMessageId ?? null,
      liked: dto.liked,
      createdDate: dto.createdDate,
      updatedDate: dto.updatedDate ?? null,
    };
  }
}
